import { AxiosResponse } from 'axios'
import Modal from 'react-bootstrap/Modal'
import { UseMutateFunction } from 'react-query'
import { useParams } from 'react-router-dom'

interface IPayload {
    id: string | undefined
    loanId: number
}
interface IModalProps {
    show: boolean
    onHide: () => void
    type: 'submit'
    mutate: UseMutateFunction<
        AxiosResponse<any, any>,
        unknown,
        IPayload,
        unknown
    >
    loanId: number
}
const DeleteModal = ({ show, onHide, type, mutate, loanId }: IModalProps) => {
    const { id } = useParams()
    return (
        <Modal
            show={show}
            onHide={onHide}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <div className=" w-full text-center py-4 text-xs">
                <p>آیا وام درخواستی لغو شود؟</p>
                <hr className=" my-2" />
                <button
                    className=" text-xs text-current cursor-pointer"
                    type={type}
                    form="authProfile"
                    onClick={() => {
                        onHide()
                        mutate({ id, loanId })
                    }}
                >
                    بله
                </button>
                <hr className=" my-2" />
                <p
                    className=" text-xs cursor-pointer  text-current"
                    onClick={onHide}
                >
                    خیر
                </p>
            </div>
        </Modal>
    )
}

export default DeleteModal
